import { ControlledInput } from 'modules/common/components';
import { Control, FormState } from 'react-hook-form';
import { getTranslation } from 'utils/getTranslation';

import { IAddLocationsFormSchema } from './schema';

export enum AddLocationsFormField {
  Name = 'name',
  Type = 'type',
  idexxAccountNumber = 'idexxAccountNumber',
  zoetisAccountNumber = 'zoetisAccountNumber',
}

type ParamType = {
  control: Control<IAddLocationsFormSchema, any>;
};
type FormErrorsType = FormState<IAddLocationsFormSchema>['errors'];

const t = getTranslation('user.CreateLocationsForm');

export const getFormFields = (params: ParamType) => {
  const { control } = params;
  const editLocationsFormFields = [
    {
      name: AddLocationsFormField.Name,
      getErrorMessage: (errors: FormErrorsType) => errors.name?.message,
      Component: () => (
        <ControlledInput
          placeholder={t('enterRegionName')}
          controlled={{
            control,
            name: AddLocationsFormField.Name,
          }}
        />
      ),
    },
    {
      name: AddLocationsFormField.idexxAccountNumber,
      getErrorMessage: (errors: FormErrorsType) =>
        errors.idexxAccountNumber?.message,
      Component: () => (
        <ControlledInput
          placeholder={t('idexxAccountNumber')}
          controlled={{
            control,
            name: AddLocationsFormField.idexxAccountNumber,
          }}
        />
      ),
    },
    {
      name: AddLocationsFormField.zoetisAccountNumber,
      getErrorMessage: (errors: FormErrorsType) =>
        errors.zoetisAccountNumber?.message,
      Component: () => (
        <ControlledInput
          placeholder={t('zoetisAccountNumber')}
          controlled={{
            control,
            name: AddLocationsFormField.zoetisAccountNumber,
          }}
        />
      ),
    },
  ];
  return editLocationsFormFields;
};
